import { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form, Field } from 'redux-form';

import { SelectField } from 'common/components/forms';
import { FormError, Button } from 'common/components/layout';
import { updateAndChargeCart, sendToHostedPayment } from 'redux/cart/actions';
import { listCustomerCreditCards } from 'redux/customerCreditCards/actions';
// import CreditCardLoggedIn from './components/CreditCardLoggedIn';

import { getAmountDue } from '../helpers';

import HostedPaymentRedirectHiddenForm from './HostedPaymentRedirectHiddenForm';
import { validateCustomerCreditCardId } from './validators';

const Payment = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [redirectObj, setRedirectObj] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(listCustomerCreditCards());
  }, [dispatch]);

  const cartReducer = useSelector((state) => state.cart);

  const onSubmit = (form) => {
    setIsSubmitting(true);
    const data = transformData(form);
    const tender = {
      tenderType: 'Credit Card',
      creditCard: data,
      amountTendered: getAmountDue(cartReducer.data)
    };
    const successFunction = (order) => {
      const { history } = props;
      history.push(`/checkout/receipt/${order.id}`);
    };
    const errorFunction = () => {
      setIsSubmitting(true);
    };
    dispatch(
      updateAndChargeCart(
        null,
        tender,
        undefined,
        undefined,
        false,
        false,
        successFunction,
        errorFunction
      )
    );
  };

  const handleBack = (e) => {
    e.preventDefault();
    const { onEdit } = props;
    onEdit('customer');
  };

  const handleSendToHostedPayment = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const redirectFunction = (response) => {
      setRedirectObj(response);
    };
    dispatch(sendToHostedPayment(redirectFunction));
  };

  const customerCreditCardsReducer = useSelector(
    (state) => state.customerCreditCard
  );

  const { handleSubmit, form } = props;
  if (redirectObj) {
    return <HostedPaymentRedirectHiddenForm redirectObj={redirectObj} />;
  }
  if (
    customerCreditCardsReducer.isFetching ||
    !customerCreditCardsReducer.data
  ) {
    return null;
  }
  const hasCreditCards = customerCreditCardsReducer.query.length > 0;
  if (hasCreditCards) {
    const creditCardArrayIds = Object.keys(customerCreditCardsReducer.data);
    const customerCreditCardArray = creditCardArrayIds.map(
      (creditCardId) => customerCreditCardsReducer.data[creditCardId]
    );
    return (
      <Form onSubmit={handleSubmit(onSubmit)} className="c7-form" method="post">
        <FormError formName={form} />
        <h3>Payment method</h3>
        <p>All transactions are secure and encrypted.</p>
        <Field
          name="customerCreditCardId"
          component={SelectField}
          optionArray={creditCardOptionArray(customerCreditCardArray)}
          label="Credit Card"
          required
        />
        <div style={{ textAlign: 'center' }}>
          <a href="" onClick={handleSendToHostedPayment}>
            Enter a new payment method
          </a>
        </div>
        <div className="c7-checkout__content__buttons">
          <Button type="submit" className="c7-button" disabled={isSubmitting}>
            Complete Order
          </Button>
          <a
            href="#"
            aria-label=" Return to customer information"
            onClick={handleBack}
          >
            Return to customer information
          </a>
        </div>
      </Form>
    );
  }
  return (
    <>
      <h3>Payment method</h3>
      <p>All transactions are secure and encrypted.</p>
      <p>&nbsp;</p>
      <div style={{ textAlign: 'center' }}>
        <Button
          type="button"
          className="c7-button"
          disabled={isSubmitting}
          onClick={handleSendToHostedPayment}
        >
          Proceed to Payment
        </Button>
      </div>
      <p>&nbsp;</p>

      <div className="c7-checkout__content__buttons">
        <a
          href="#"
          aria-label="Return to cutomer information"
          onClick={handleBack}
        >
          Return to customer information
        </a>
      </div>
    </>
  );
};

const creditCardOptionArray = (creditCards) => {
  const array = [];
  creditCards.forEach((creditCard) => {
    array.push({ option: creditCardOneLine(creditCard), value: creditCard.id });
  });
  return array;
};

const creditCardOneLine = (card) =>
  `${card.maskedCardNumber} Exp: ${card.expiryMo}/${card.expiryYr}`;

const transformData = (values) => {
  const data = {
    customerCreditCardId: values.customerCreditCardId
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateCustomerCreditCardId(data);
  return errors;
};

const mapStateToProps = (state) => {
  const initialValues = {};
  if (state.cart && state.cart.data) {
    const { tenders } = state.cart.data;
    if (tenders.length > 0) {
      if (tenders[0].tenderType === 'Credit Card') {
        const { creditCard } = tenders[0];
        initialValues.customerCreditCardId = creditCard.customerCreditCardId;
      }
    }
  }
  return {
    initialValues
  };
};

const PaymentForm = reduxForm({
  form: 'paymentLoggedInPickup',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Payment);

export default withRouter(connect(mapStateToProps)(PaymentForm));
